export const state = () => ({
  list: [
    { language: "fa", name: "Farsi", align: "rtl" },
    { language: "en", name: "English", align: "ltr" },
  ],
  isRtl: false,
});

export const actions = {
  setDir({ commit }) {
    document.body.className = "rtl";
    commit("SET_DIR", true);
  },
};

export const mutations = {
  SET_DIR(state, status) {
    state.isRtl = status;
  },
};
